import React from 'react';
import ParkingSpotMarker from './ParkingSpotMarker';

const ParkingSpotMarkerLayer = ({ features }) => {
  return (
    <div>
      {
        features.map((feature) => {
          const { spotid, OBJECTID } = feature.properties;

          return (
            <ParkingSpotMarker key={`${spotid}-${OBJECTID}`} feature={feature} />
          );
        })
      }
    </div>
  );
};

export default ParkingSpotMarkerLayer;



// WEBPACK FOOTER //
// ./src/containers/MapLayers/ParkingSpotMarkerLayer.js